export default __webpack_public_path__ + "static/kaczorowska-c976aea40ffc3529f0ee23a050d4d8be.jpg";